import React from 'react';
import { cn } from '@/lib/utils';

export type PillTone = 'success' | 'warning' | 'info' | 'danger' | 'neutral';

const tones: Record<PillTone, string> = {
  success: 'tw-bg-ds-success-bg tw-text-ds-success-fg',
  warning: 'tw-bg-ds-warning-bg tw-text-ds-warning-fg',
  info: 'tw-bg-ds-info-bg tw-text-ds-info-fg',
  danger: 'tw-bg-ds-danger-bg tw-text-ds-danger-fg',
  neutral: 'tw-bg-ds-subtle tw-text-ds-text-secondary',
};

interface StatusPillProps {
  tone: PillTone;
  children: React.ReactNode;
  className?: string;
}

/** Rounded status label with a leading dot (Figma "Badge"/"Status"). */
const StatusPill: React.FC<StatusPillProps> = ({ tone, children, className }) => (
  <span
    className={cn(
      'tw-inline-flex tw-shrink-0 tw-items-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-full tw-px-2.5 tw-py-1 tw-text-[12px] tw-font-semibold tw-leading-4',
      tones[tone],
      className,
    )}
  >
    <span aria-hidden className="tw-h-1.5 tw-w-1.5 tw-rounded-full tw-bg-current" />
    {children}
  </span>
);

export default StatusPill;
